import Card from "components/Card/Card";
import { ControlledInput } from "components/Card/ControlledInput";
import { TextInput } from "components/inputs";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import type { ConstantTypes, TinType } from "types/DataTypes";

type RRETinBasicInfoSectionProps = {
  control: Control<TinType>;
  getValues: UseFormGetValues<TinType>;
  setValue: UseFormSetValue<TinType>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const RRETinBasicInfoSection = ({
  control,
  handleFieldChange,
}: RRETinBasicInfoSectionProps) => {
  return (
    <Card heading="Basic TIN Information">
      <ControlledInput
        control={control}
        name="tin"
        label="TIN"
        placeholder="Enter TIN"
        errors={{}}
        onSave={(value) => handleFieldChange("tin", value)}
        componentType={TextInput}
        maxLength={9}
        mask="number"
      />

      <ControlledInput
        control={control}
        name="office_code"
        label="Office Code"
        placeholder="Enter Office Code"
        errors={{}}
        onSave={(value) => handleFieldChange("office_code", value)}
        componentType={TextInput}
        maxLength={9}
        mask="number"
      />

      <ControlledInput
        control={control}
        name="tin_office_code_mailing_name"
        label="TIN Office Code Mailing Name"
        placeholder="Enter TIN Office Code Mailing Name"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("tin_office_code_mailing_name", value)
        }
        componentType={TextInput}
        maxLength={70}
        type="text"
      />
    </Card>
  );
};

export default RRETinBasicInfoSection;
